import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
export function ActionButton(t0) {
  const $ = _c(7);
  const {
    icon,
    label,
    onClick,
    disabled: t1,
    active: t2,
    isToggle: t3
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const active = t2 === undefined ? false : t2;
  const isToggle = t3 === undefined ? false : t3;
  const stateClasses = active ? "tw-border-primary-500/50 tw-bg-primary-500/10 tw-text-primary-400 desktop-hover:hover:tw-border-primary-400/70 desktop-hover:hover:tw-bg-primary-500/15 desktop-hover:hover:tw-text-primary-300" : "tw-border-white/5 tw-bg-iron-950 tw-text-iron-300 desktop-hover:hover:tw-border-white/10 desktop-hover:hover:tw-bg-iron-900 desktop-hover:hover:tw-text-iron-100";
  const t4 = isToggle ? active : undefined;
  const t5 = `tw-inline-flex tw-items-center tw-justify-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-lg tw-border tw-border-solid tw-px-3 tw-py-2 tw-text-xs tw-font-medium tw-transition tw-duration-200 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 ${stateClasses}`;
  let t6;
  if ($[0] !== disabled || $[1] !== icon || $[2] !== label || $[3] !== onClick || $[4] !== t4 || $[5] !== t5) {
    t6 = <button type="button" onClick={onClick} disabled={disabled} aria-pressed={t4} className={t5}>{icon}{label}</button>;
    $[0] = disabled;
    $[1] = icon;
    $[2] = label;
    $[3] = onClick;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
export function DraftChipButton(t0) {
  const $ = _c(6);
  const {
    label,
    onClick,
    disabled: t1,
    active: t2,
    compact: t3,
    isToggle: t4
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const active = t2 === undefined ? false : t2;
  const compact = t3 === undefined ? false : t3;
  const isToggle = t4 === undefined ? false : t4;
  let stateClasses = "tw-border-white/5 tw-bg-iron-950 tw-text-iron-300 desktop-hover:hover:tw-border-white/10 desktop-hover:hover:tw-bg-iron-900 desktop-hover:hover:tw-text-iron-100";
  if (active) {
    stateClasses = "tw-border-primary-500/50 tw-bg-primary-500/10 tw-text-primary-400 desktop-hover:hover:tw-border-primary-400/70 desktop-hover:hover:tw-bg-primary-500/15 desktop-hover:hover:tw-text-primary-300";
  }
  const sizeClasses = compact ? "tw-px-2.5 tw-py-1 tw-text-xs" : "tw-px-3 tw-py-1.5 tw-text-xs";
  const t5 = isToggle ? active : undefined;
  const t6 = `tw-rounded-lg tw-border tw-border-solid tw-font-medium tw-transition tw-duration-200 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 ${sizeClasses} ${stateClasses}`;
  let t7;
  if ($[0] !== disabled || $[1] !== label || $[2] !== onClick || $[3] !== t5 || $[4] !== t6) {
    t7 = <button type="button" onClick={onClick} disabled={disabled} aria-pressed={t5} className={t6}>{label}</button>;
    $[0] = disabled;
    $[1] = label;
    $[2] = onClick;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  return t7;
}